import { hasGPC, hasGIC } from '@/utils/conference-type';

export const PHOTODROP_MEMENTO_URL = 'https://gens.app/gpc2026-photodrop';
export const PHOTODROP_MEMENTO_URL_GIC = 'https://gens.app/gic4-2026-photodrop';

const MEMENTO_LAUNCH_YEAR = 2026;

// True once the delegate has a GPC conference record for the year the memento
// photo platform launched. Delegates without that record still get the old
// PhotoDrop gallery.
export const hasMementoAccess = conferences => hasGPC(conferences, MEMENTO_LAUNCH_YEAR);

// GIC memento access isn't tied to a specific edition yet — any GIC conference
// record qualifies. Tighten this to a specific edition once that's defined.
export const hasGicMementoAccess = conferences => hasGIC(conferences);

// Builds the Memento Photo join URL with the delegate's details prefilled.
// The gens.app shortlink redirects to memento.photo/j/… and must be configured
// to forward query params, or the prefill is lost.
// Accepts profile store fields; missing values become empty params.
// Memento's template is ?firstname={full name}&email={email}&tags={comma separated},
// where firstname carries the delegate's full name. Country and group land in
// tags (e.g. tags=Singapore,Team A) so Memento can bucket photos by both.
export const buildPhotodropMementoUrl = ({
  name = '',
  email = '',
  country = '',
  groupName = '',
  baseUrl = PHOTODROP_MEMENTO_URL,
} = {}) => {
  const params = new URLSearchParams({
    firstname: name,
    email,
  });
  // Tags are joined with literal commas to match Memento's template link;
  // each tag is still encoded individually so values stay URL-safe.
  const tags = [country, groupName].filter(Boolean).map(encodeURIComponent).join(',');
  return `${baseUrl}?${params.toString()}&tags=${tags}`;
};
